import { InjectionToken, FactoryProvider, PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";

export const LOCAL_STORAGE = new InjectionToken<Storage>('LocaleStorage');

export function LOCAL_STORAGE_PROVIDER_FACTORY(platformId: Object): Storage | Object {
    if (isPlatformBrowser(platformId)) {
        return localStorage;
    }

    return new Object();
}

export const LOCAL_STORAGE_PROVIDER: FactoryProvider = {
    provide: LOCAL_STORAGE,
    deps: [PLATFORM_ID],
    useFactory: LOCAL_STORAGE_PROVIDER_FACTORY
}
